/* eslint-disable import/prefer-default-export */

export enum ReleaseNoteType {
  DRAFT = 'DRAFT',
  INTERNAL_ONLY = 'INTERNAL_ONLY',
  PUBLIC = 'PUBLIC',
}
